import React from 'react'
import {
  useForTablet,
  IsEmbedded,
  NotEmbedded,
  Navbar,
} from '@sketch/components'
import { SketchHomeButton } from '@sketch/modules-common'
import { ShareWithoutVersion } from 'modules/versioning'
import BackButton, {
  useBackButton,
} from '../../../../shares/components/BackButton'
import HeaderBadge from '../../../../shares/components/HeaderBadge'
import * as S from './PrototypeHeader.styles'
import { ArtboardSelector } from '../ArtboardSelector'
import { PrototypeControls } from '../PrototypeControls'
import { ArtboardLink } from '../ArtboardLink'
import { ResizeModeSelector } from '../ResizeModeSelector'
import { EnterFullScreenButton } from '../EnterFullScreenButton'
import { usePrototypeContext } from '../../hooks'

type PrototypeHeaderProps = {
  setSidebarLeftOpen?: React.Dispatch<React.SetStateAction<boolean>>
  share: ShareWithoutVersion
}

export const PrototypeHeader: React.FC<PrototypeHeaderProps> = ({
  setSidebarLeftOpen,
  share,
}) => {
  const isTabletAndBigger = useForTablet()
  const { link: shouldRenderBackButton } = useBackButton()
  const { isFullscreen } = usePrototypeContext()

  if (isFullscreen) {
    return null
  }

  return (
    <Navbar data-testid="prototype-header">
      <NotEmbedded>
        <Navbar.Section>
          <HeaderBadge
            workspace={share.workspace}
            setSidebarLeftOpen={setSidebarLeftOpen}
          />
          {isTabletAndBigger && shouldRenderBackButton && (
            <S.BackButtonItem>
              <BackButton />
            </S.BackButtonItem>
          )}
          <ArtboardSelector />
        </Navbar.Section>
        {!isTabletAndBigger && (
          <S.Item>
            <ArtboardLink />
          </S.Item>
        )}
        {isTabletAndBigger && (
          <Navbar.Section align="end">
            <S.Item>
              <PrototypeControls />
            </S.Item>
            <S.Item>
              <ResizeModeSelector />
            </S.Item>
            <S.Item>
              <ArtboardLink />
            </S.Item>
            <S.Item>
              <EnterFullScreenButton />
            </S.Item>
          </Navbar.Section>
        )}
      </NotEmbedded>
      <IsEmbedded>
        <Navbar.Section>
          <SketchHomeButton />
          {shouldRenderBackButton && (
            <S.BackButtonItem>
              <BackButton />
            </S.BackButtonItem>
          )}
        </Navbar.Section>
      </IsEmbedded>
    </Navbar>
  )
}
